import { createApi , fetchBaseQuery} from '@reduxjs/toolkit/query/react'

const tmdbApiKey = process.env.REACT_APP_TMDB_KEY;

// /movie/popular?api_key=<<api_key>>&language=en-US&page=1

export const tmdbApi = createApi({
    reducerPath: '',
    baseQuery: fetchBaseQuery({ baseUrl: 'https://api.themoviedb.org/3'}),
    endpoints: (builder)=>({
        getGenres:builder.query({
            query:() => `genre/movie/list?api_key=${tmdbApiKey}`
        }),

        // GET MOVIES BY TYPE
         getMovies: builder.query({
            query: ({genreIdOrCategoryName, page , searchQuery}) => {
                //--Get Movies by Search
                if(searchQuery){
                    return `search/movie?query=${searchQuery}&page=${page}&api_key=${tmdbApiKey}`
                }

                //--Get Movies by Genre
                if(genreIdOrCategoryName && typeof genreIdOrCategoryName === 'string'){
                    return `movie/${genreIdOrCategoryName}?page=${page}&api_key=${tmdbApiKey}`
                }

                //--Get Popular Movies
                if(genreIdOrCategoryName && typeof genreIdOrCategoryName === 'number'){
                    return `discover/movie?with_genres=${genreIdOrCategoryName}&page=${page}&api_key=${tmdbApiKey}`
                }
                return `movie/popular?page=${page}&api_key=${tmdbApiKey}`
            }
         }),

         //--Get Movie
         getMovie: builder.query({
           query: (id) => `/movie/${id}?append_to_response=videos,credits&api_key=${tmdbApiKey}`,
         }),

         //----GET user Specific List
        getList: builder.query({
            query: ({listName,accountId,sessionId,page}) => `/account/${accountId}/${listName}?api_key=${tmdbApiKey}&session_id=${sessionId}&page=${page}`
        }),

         getRecommendation: builder.query({
            query: ({movie_id, list}) => `/movie/${movie_id}/${list}?api_key=${tmdbApiKey}`
         }),

         getActorsdetails:builder.query({
            query: (id) => `person/${id}?api_key=${tmdbApiKey}`
         }),

         getMoviesByActorId: builder.query({
            query: ({id, page}) => `/discover/movie?with_cast=${id}&page=${page}&api_key=${tmdbApiKey}`
         }),
    })
})

export const {
    useGetGenresQuery,
    useGetMoviesQuery,
    useGetMovieQuery,
    useGetListQuery,
    useGetRecommendationQuery,
    useGetActorsdetailsQuery,
    useGetMoviesByActorIdQuery,
} = tmdbApi;